module.exports = __webpack_public_path__ + "img/hoofdgraphic-homepage.76a5d14a.svg";